import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Row, Col } from 'reactstrap';
import FontAwesome from 'react-fontawesome';
import { getCloudImageUrl } from '../../../utils/Helpers';
import promo1 from '../../../images/sample/sample1.webp';
import promo2 from '../../../images/sample/sample2.webp';
import promo3 from '../../../images/sample/sample3.webp';
import { sliderBanner, sliderItemClick } from '../../../actions/slidersAction';
import Analytics from '../../../services/Analytics';
import KickCarousel from '../KickCarousel';

class PromoBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageBanner: [
        {
          imgSrc: promo1,
          name: 'Promo 1',
          redirect_url:
            'https://www.kickavenue.com/sneakers/16774/jordan-1-retro-high-white-university-blue-black',
        },
        {
          imgSrc: promo2,
          name: 'Promo 2',
          redirect_url:
            'https://www.kickavenue.com/sneakers/21271/jordan-1-low-crimson-tint',
        },
        {
          imgSrc: promo3,
          name: 'Promo 3',
          redirect_url:
            'https://www.kickavenue.com/sneakers/21409/yeezy-boost-350-v2-ash-pearl',
        },
      ],
      activeSlide: 0,
      pause: true,
    };
  }

  componentDidMount() {
    this._getSliderBanner();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.category !== this.props.category) {
      this._getSliderBanner();
    }
  }

  _getSliderBanner = async () => {
    const { dataCategory } = this.props;
    const newCategory =
      dataCategory === 'harbolnas' ? 'novembazaar' : dataCategory;
    const params = { params: { category: newCategory } };

    await this.setState({
      activeSlide: 0,
      pause: true,
    });

    this.props.sliderBanner(params);
  };

  _handleSliderClick(id: number) {
    const { dataAuth } = this.props;
    const payload = {
      slider_id: id,
      action: 'SLIDER_ITEM_CLICK',
      user_id: dataAuth.isLogged ? dataAuth.userdata.id : null,
      app_os: 'Web',
    };

    const sliderProperties = {
      userId: dataAuth.isLogged ? dataAuth.userdata.id : 'Anonymous',
      app_os: 'Web',
      slider_id: id,
    };

    this.props.sliderItemClick(payload);
    Analytics.recordSliders('slider_item_click', sliderProperties);
  }

  renderCarousel = () => {
    const { sliderImages, category, dataAuth } = this.props;
    return (
      <>
        {sliderImages.images.length && !sliderImages.error ? (
          <KickCarousel
            activeIndex={this.state.activeSlide}
            pause={this.state.pause}
            sliders={sliderImages.images}
            sliderState={this.state.imageSliders}
            onActiveIndexChanged={(index) =>
              this.setState({ activeSlide: index })
            }
            dataAuth={dataAuth}
            history={this.props.history}
            onSliderClick={() => this._handleSliderClick()}
          />
        ) : null}
      </>
    );
  };

  navigateToPage = (item) => {
    this.props.history.push(item.redirect_url);
  };

  render() {
    return (
      <div className="promo-banner-general">
        {this.state.imageBanner &&
          this.state.imageBanner.map((item, index) => {
            return (
              <div onClick={() => this.navigateToPage(item)}>
                <KickImage
                  src={item.imgSrc}
                  style={{
                    marginBottom:
                      index == this.state.imageBanner.length - 1 && '0px',
                  }}
                />
              </div>
            );
          })}
      </div>
    );
  }
}

interface State {
  sliderHome: any;
  dataAuth: any;
}

const mapStateToProps = (state: State) => ({
  sliderImages: state.sliderHome,
  dataAuth: state.dataAuth,
});

const mapDispatchToProps = (dispatch: any) => ({
  sliderBanner: (payload: Object) => dispatch(sliderBanner(payload)),
  sliderItemClick: (payload: Object) => dispatch(sliderItemClick(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoBanner);
